import { render } from "./Antragsdatum.pug?vue&type=template&id=0bb54be7&lang=pug"
import script from "./Antragsdatum.js?vue&type=script&lang=js"
export * from "./Antragsdatum.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__